import { render, staticRenderFns } from "./CourseDetailPage.vue?vue&type=template&id=12d53c6d&lang=true&"
import script from "./CourseDetailPage.vue?vue&type=script&lang=js&"
export * from "./CourseDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./CourseDetailPage.vue?vue&type=style&index=0&id=12d53c6d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports